import React from 'react';
import { InstitutionsList } from './InstitutionsList';
import { StatusBar } from './StatusBar';
import type { AccountWithPositions } from '../ui/container-utils';

interface PositionsPanelProps {
  institutionGroups: any[];
  storeConnections: any[];
  connectionsLoading: boolean;
  multiStore: any;
  wealthicaAccountsLength: number;
  accountsWithPositions: AccountWithPositions[];
  loadingPositionsFor: any;
  isLoadingPositions: boolean;
  expandedAccounts: string[];
  setExpandedAccountsList: (expanded: string[]) => void;
  loadPositionsForAccount: (accountId: string) => void | Promise<void>;
  onPositionClick: (pos: any) => void;
  defaultLastSyncAt: any;
  disconnectAccount: (
    vars: { institutionId: string },
    options: { onSuccess: () => void; onError: (error: any) => void }
  ) => void;
  persistDataPreference: boolean;
  setPersistDataPreference: (v: boolean) => void;
}

export function PositionsPanel({
  institutionGroups,
  storeConnections,
  connectionsLoading,
  multiStore,
  wealthicaAccountsLength,
  accountsWithPositions,
  loadingPositionsFor,
  isLoadingPositions,
  expandedAccounts,
  setExpandedAccountsList,
  loadPositionsForAccount,
  onPositionClick,
  defaultLastSyncAt,
  disconnectAccount,
  persistDataPreference,
  setPersistDataPreference,
}: PositionsPanelProps) {
  const isProcessing = storeConnections.some(
    (c) => !!(c as any).isPersisting || (c as any).processingState === 'processing'
  );

  return (
    <div className="space-y-4">
      <InstitutionsList
        institutionGroups={institutionGroups}
        storeConnections={storeConnections}
        connectionsLoading={connectionsLoading}
        multiStore={multiStore}
        wealthicaAccountsLength={wealthicaAccountsLength}
        accountsWithPositions={accountsWithPositions}
        loadingPositionsFor={loadingPositionsFor}
        isLoadingPositions={isLoadingPositions}
        expandedAccounts={expandedAccounts}
        setExpandedAccountsList={setExpandedAccountsList}
        loadPositionsForAccount={loadPositionsForAccount}
        onPositionClick={onPositionClick}
        defaultLastSyncAt={defaultLastSyncAt}
        disconnectAccount={disconnectAccount}
      />

      <StatusBar
        persistDataPreference={persistDataPreference}
        setPersistDataPreference={setPersistDataPreference}
        isProcessing={isProcessing}
      />
    </div>
  );
}
